module.exports = __webpack_public_path__ + "media/images/WalletConnet-6908550d.svg";